import { ThemeProvider } from "@emotion/react";
import Router from "./commons/navigation/Router";
import { theme } from "./commons/constants/theme";
import "./commons/firebase/FirebaseConfig";

// Los metadatos viven en public/index.html: los crawlers de WhatsApp/X/Facebook
// no ejecutan JS, así que escribirlos en runtime no servía de nada.
function App() {
	return (
		<ThemeProvider theme={theme}>
			<Router />
		</ThemeProvider>
	);
}

export default App;
